import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doPostFiles, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getProjectManagement = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/management`
  return doGet(url)
}

export const saveProjectManagement = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/management`
  return doPost(url, request)
}

export const getProjectManagementItem = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/management/item`
  return doGet(url)
}

export const getProjectManagementByItem = (id, itemId) => {
  const url = `${API_ROOT}/proposal/${id}/project/management/item/${itemId}`
  return doGet(url)
}

export const saveProjectManagementByItem = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/management/item/`
  return doPost(url, request)
}

export const updateProjectManagementByItem = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/management/item/${request.id}`
  return doPut(url, request)
}

export const deleteProjectManagementByItem = (id, itemId) => {
  const url = `${API_ROOT}/proposal/${id}/project/management/item/${itemId}`
  return doDelete(url)
}

//Attachments
export const getAttachments = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/management/attachments`
  return doGet(url)
}

export const getAttachmentsByFileId = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/project/management/attachments/${fileId}`
  return doGet(url)
}
export const getDownload = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/project/management/attachments/${fileId}/download`
  return doDownload(url)
}

export const saveAttachments = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/management/attachments`
  return doPostFiles(url, request)
}

export const updateAttachments = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/management/attachments/${request.id}`
  return doPut(url, request)
}

export const deleteAttachments = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/project/management/attachments/${fileId}`
  return doDelete(url)
}
